import React, {useState} from 'react';
import {Row,Col} from 'antd';
import InputField from '../../../../input-field';
import DividerBlock from '../../../../divider-block';
import SelectField from "../../../../select-field";
import {systemService} from "../../../../../services";
import i18n from "../../../../../i18n";

export default function SecondStep({ setFields, stepFields, getFieldErrors, organizationalForm, country, isProprietor }) {

    let dividerStyle = { margin: '15px 0px 45px 0px', display: "block", clear: "both", width: "100%", minWidth: "100%", height: "1px" }
    const firstToUpper = (string) => {
        return string.charAt(0).toUpperCase() + string.slice(1);
    };

    function getBanks(bic, setBanksList) {
        systemService.getBanksList(bic)
            .then(data => {
                setBanksList(data);
            })
            .catch();
    }

    return (
        <>
            <span className="divider-label">{i18n.t('modals.modalCreateNewLegalEntity.divider.boss')}</span>
            <DividerBlock style={dividerStyle} />
          <Row gutter={[12, 24]}>
         <Col lg={8} sm={24} >
                <InputField name="secondName" label={i18n.t('modals.modalCreateNewLegalEntity.fields.secondName.title')} value={stepFields.secondName} setValue={value => setFields({...stepFields, secondName: firstToUpper(value)})} getFieldErrors={getFieldErrors} />
            </Col>
            <Col lg={8} sm={24} >
              <InputField name="firstName" label={i18n.t('modals.modalCreateNewLegalEntity.fields.firstName.title')} value={stepFields.firstName} setValue={value => setFields({...stepFields, firstName: firstToUpper(value)})} getFieldErrors={getFieldErrors} />
            </Col>
         <Col lg={8} sm={24} >
              <InputField name="patronymic" label={i18n.t('modals.modalCreateNewLegalEntity.fields.patronymic.title')} value={stepFields.patronymic} setValue={value => setFields({...stepFields, patronymic: firstToUpper(value)})} getFieldErrors={getFieldErrors} />
            </Col>
          </Row>
          <Row gutter={[12, 24]}>
            { !isProprietor ?
              <>
             <Col lg={8} sm={24} >
                  <InputField name="position" label={i18n.t('modals.modalCreateNewLegalEntity.fields.position.title')} value={stepFields.position} setValue={value => setFields({...stepFields, position: firstToUpper(value)})} getFieldErrors={getFieldErrors} />
                </Col>
                  <Col lg={8} sm={24} >
                      <SelectField
                          title={i18n.t('modals.modalCreateNewLegalEntity.fields.legalReason.title')}
                          name="legalReason"
                          selectedValue={stepFields.legalReason}
                          values={stepFields.legalReasonsList}
                          onChange={(value) => {
                              setFields({
                                  ...stepFields,
                                  legalReason: value,
                              });
                          }}
                          getErrors={getFieldErrors}
                          placeholder={i18n.t('modals.modalCreateNewLegalEntity.fields.legalReason.placeholder')}
                          notFoundText={null}
                          showArrow={true}
                          style={{ width: "100%" }}
                      />
                  </Col>
              </> :
                <>
                    <Col lg={8} sm={24} >
                        <InputField
                            name="legalReason"
                            isDisabled={true}
                            label={i18n.t('modals.modalCreateNewLegalEntity.fields.legalReason.title')}
                            value={i18n.t('modals.modalCreateNewLegalEntity.fields.legalReason.value')}
                            setValue={value => setFields({...stepFields, legalReason: value})}
                            getFieldErrors={getFieldErrors}
                        />
                    </Col>
                </>
            }
          </Row>

            <span className="divider-label">{i18n.t('modals.modalCreateNewLegalEntity.divider.bank')}</span>
            <DividerBlock style={dividerStyle} />
          <Row gutter={[12, 24]}>
            <Col lg={6} sm={24} >
              <InputField name="rs" label={i18n.t('modals.modalCreateNewLegalEntity.fields.rs.title')} value={stepFields.rs} setValue={value => setFields({...stepFields, rs: value.replace(/[^0-9]/g, '')})} getFieldErrors={getFieldErrors} />
            </Col>

            {country !== 1 ? (
                <Col lg={6} sm={24} >
                    <InputField name="bic" label={i18n.t('modals.modalCreateNewLegalEntity.fields.bic.title')} value={stepFields.bic} setValue={value => setFields({...stepFields, bic: value})} getFieldErrors={getFieldErrors} />
                </Col>
            ) : (
                <Col lg={10} sm={24} >
                    <SelectField
                        title={i18n.t('modals.modalCreateNewLegalEntity.fields.bic.title')}
                        name="bic"
                        selectedValue={stepFields.bic}
                        values={stepFields.banksList}
                        onChange={(value) => {
                            setFields({
                                ...stepFields,
                                bic: value,
                            });
                        }}
                        onSearch={(value) => {
                            if (value.length > 2) {
                                getBanks(value, (data) => {
                                    setFields({
                                        ...stepFields,
                                        banksList: data
                                    });
                                });
                            }
                        }}
                        getErrors={getFieldErrors}
                        placeholder={i18n.t('modals.modalCreateNewLegalEntity.fields.bic.placeholder')}
                        notFoundText={null}
                        showArrow={false}
                        style={{ width: "100%" }}
                    />
                </Col>
            )}
            {country !== 1 ? (
                <>
                  <Col lg={6} sm={24} >
                    <InputField name="bankName" label={i18n.t('modals.modalCreateNewLegalEntity.fields.bankName.title')} value={stepFields.bankName} setValue={value => setFields({...stepFields, bankName: value})} getFieldErrors={getFieldErrors} />
                  </Col>
                  <Col lg={6} sm={24} >
                    <InputField name="bankCorS" label={i18n.t('modals.modalCreateNewLegalEntity.fields.bankCorS.title')} value={stepFields.bankCorS} setValue={value => setFields({...stepFields, bankCorS: value})} getFieldErrors={getFieldErrors} />
                  </Col>
                </>
            ) : null}
          </Row>
        </>
    );
}
